var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import { mapGetters, mapActions } from 'vuex';
import { ACCOUNT, ACCOUNT_CHECKOUT } from '@/stores/defs';
import FormValidator from "@/utils/FormValidator";
import { isEmpty } from 'lodash';
import locationsMixin from '@Mixin/locationsMixin';
import customerService from '@Service/customer.service';
import guestService from '@Service/guest.service';
import localStorageAdapter from '@/utils/LocalStorageAdapter';
import storeLoaderMixin from '@Mixin/storeLoaderMixin';
import Promise from 'ts-promise';
var accountMixin = {
    mixins: [
        locationsMixin,
        storeLoaderMixin,
    ],
    computed: __assign({}, mapGetters({
        loggedIn: ACCOUNT.GET_LOGGED_IN,
        isGuest: ACCOUNT_CHECKOUT.GET_IS_GUEST,
        guestName: ACCOUNT.GET_GUEST_NAME,
        guestPhone: ACCOUNT.GET_GUEST_PHONE,
        guestId: ACCOUNT_CHECKOUT.GET_GUEST_ID,
        guestAddress: ACCOUNT.GET_GUEST_ADDRESS,
        customer: ACCOUNT.GET_CUSTOMER,
        isNewAccount: ACCOUNT.GET_IS_NEW_ACCOUNT,
    }), { isLoggedIn: function () {
            return (this.loggedIn);
        },
        userPhone: function () {
            var customer = this.customer;
            if (customer.exists()) {
                return customer.phone;
            }
            return this.guestPhone || 'unknown';
        },
        userName: function () {
            var customer = this.customer;
            if (customer.exists()) {
                return customer.firstName;
            }
            return this.guestName || null;
        },
        userId: function () {
            if (this.isGuestLogin) {
                return this.guestId;
            }
            if (this.isLoggedIn) {
                return this.customer.id;
            }
            return null;
        },
        // TODO could use better naming "hasValid" vs "valid" is not distinct
        validPhone: function () {
            var phone = this.userPhone;
            var validatePhoneNumber = this.hasValidPhone(phone);
            return (validatePhoneNumber === 'success');
        },
        isGuestLogin: function () {
            return !this.loggedIn && this.isGuest;
        },
        isNoLogin: function () {
            return !this.loggedIn && !this.isGuest;
        } }),
    // TODO might want to incorporate recent order store
    methods: __assign({}, mapActions({
        setCustomer: ACCOUNT.SET_CUSTOMER,
        updateCustomer: ACCOUNT.UPDATE_CUSTOMER,
        setLoggedIn: ACCOUNT.SET_LOGGED_IN,
        setIsGuest: ACCOUNT_CHECKOUT.SET_IS_GUEST,
        setGuestId: ACCOUNT_CHECKOUT.SET_GUEST_ID,
        setIsNewAccount: ACCOUNT.SET_IS_NEW_ACCOUNT,
        setGuestAddress: ACCOUNT.SET_GUEST_ADDRESS,
    }), { hasActiveOrder: function () {
            if (!this.isLoggedIn) {
                return false;
            }
        },
        hasReorder: function () {
            if (!this.isLoggedIn) {
                return false;
            }
        },
        hasValidPhone: function (phone) {
            if (isEmpty(phone)) {
                return 'empty';
            }
            var valid = FormValidator.validatePhone(phone);
            return valid ? 'success' : 'error';
        },
        hasValidName: function (name) {
            var valid = !isEmpty(name);
            return valid ? 'success' : 'empty';
        },
        hasValidEmail: function (email) {
            if (isEmpty(email)) {
                return 'empty';
            }
            var valid = FormValidator.validateEmail(email);
            return valid ? 'success' : 'error';
        },
        validateGuest: function () {
            var guestName = this.guestName;
            var guestPhone = this.guestPhone;
            var validatePhoneNumber = this.hasValidPhone(guestPhone);
            var validPhone = (validatePhoneNumber === 'success');
            return !isEmpty(guestName) && validPhone;
        },
        validateAccount: function () {
            if (this.isLoggedIn) {
                return true;
            }
            if (this.validateGuest()) {
                return true;
            }
            return false;
        },
        loginGateWithLoader: function (loader) {
            var _this = this;
            var vue = this;
            var locationBase = this._locationId;
            var verifyCallback = function (response) {
                var data = response && response.data;
                var body = data && data.body;
                var loggedIn = body && body.loggedIn;
                if (loggedIn) {
                    loader.hide();
                }
                if (!loggedIn) {
                    guestService.fetchGuestCustomer(locationBase, function (_a) {
                        var customerId = _a.customerId, success = _a.success;
                        if (!success) {
                            vue.loginGateWithLoader(loader);
                            return;
                        }
                        _this.updateCustomer({
                            paymentAccounts: [],
                        });
                        _this.setGuestId(customerId);
                        loader.hide();
                    });
                }
            };
            var afterLoadAll = function () {
                var customerId = localStorageAdapter.getCustomerBase();
                customerService.verifyLoginStatus(customerId).then(verifyCallback);
            };
            this.loadAll(locationBase, true).then(function () {
                afterLoadAll();
            });
        },
        _saveProperties: function () {
            var apiReq = {
                lb: this.location.id,
                cmd: 'guest_update',
                c: {
                    base: this.guestId,
                    phone: this.guestPhone,
                    email: this.guestEmail,
                    firstname: this.guestName,
                }
            };
            return customerService.editProfile(apiReq);
        },
        _validateGuestForOrder: function (order) {
            var _this = this;
            var validateCustomer = customerService.validateCustomer(this.guestId);
            var validateCustomerPromise = new Promise(function (resolve, reject) {
                validateCustomer.then(function (value) {
                    if (!value) {
                        var locationBase = _this.location.id;
                        guestService.fetchGuestCustomer(locationBase, function (_a) {
                            var customerId = _a.customerId, success = _a.success;
                            if (success) {
                                _this.updateCustomer({
                                    paymentAccounts: [],
                                });
                                _this.setGuestId(customerId);
                                order.customer = customerId;
                                var propsSaved = _this._saveProperties();
                                propsSaved.then(function () {
                                    resolve(true);
                                    return;
                                }).catch(function () {
                                    reject(new Error("error processing guest customer"));
                                });
                                return;
                            }
                            reject(new Error("error processing guest customer"));
                        });
                        return;
                    }
                    resolve(true);
                });
            });
            return validateCustomerPromise;
        } }),
};
export default accountMixin;



//////////////////
// WEBPACK FOOTER
// ./src/components/mixins/accountMixin.ts
// module id = 7cRv
// module chunks = 18